import { useQuery } from "@tanstack/react-query";
import lensService from "../../../services/lensService";

// Archived playbooks included; the list filters them itself so its counts come from one array.
const usePlaybooks = () =>
    useQuery({
        queryKey: ["lens", "playbooks"],
        queryFn: () => lensService.fetchPlaybooks(true),
        refetchInterval: (query) =>
            query.state.data?.some((playbook) => playbook.generationStatus === "generating") ? 5000 : false,
    });

export default usePlaybooks;
